import cx from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';

import {Footer} from '@udemy/footer';
import {Toaster} from '@udemy/react-messaging-components';
import {useStores} from '@udemy/store-provider';

import {Header} from 'src/components/header';
import {RootStore} from 'src/stores/root-store';

import styles from './devhub-layout.module.less';

export const getDevHubLayout = (page: React.ReactElement) => {
    return <DevHubLayout>{page}</DevHubLayout>;
};

export const getFullPageDevHubLayout = (page: React.ReactElement) => {
    return <DevHubLayout fullWidth={true}>{page}</DevHubLayout>;
};

const DevHubLayout = observer(
    ({children, fullWidth = false}: {children: React.ReactElement; fullWidth?: boolean}) => {
        const [rootStore] = useStores([RootStore]);
        return (
            <div className={styles['container']}>
                <Header />
                <main className={cx(styles['content'], {[styles['fixed-width']]: !fullWidth})}>
                    {children}
                </main>

                <Footer serverProps={rootStore.footerData} />
                <Toaster />
            </div>
        );
    },
);
